import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import apiService from '../services/apiService';
import Rail from '../ui/Rail';
import Poster from '../ui/Poster';
import { useCatalog } from '../providers/CatalogProvider';

/**
 * Recommandations personnalisées (calculées côté serveur).
 *
 * Réécrit pour s'appuyer sur `Rail` + `Poster` : mêmes données, mais la
 * section adopte le rendu commun du catalogue au lieu de sa propre grille et
 * de ses propres cartes. Un rail de plus, pas un composant de plus à maintenir.
 */
export default function RecommendedMovies({ user, onSelectMovie }) {
  const catalog = useCatalog();
  const [items, setItems] = useState([]);
  const [state, setState] = useState('loading');

  useEffect(() => {
    if (!user) return undefined;

    let cancelled = false;
    setState('loading');

    apiService
      .getRecommendations(14)
      .then((response) => {
        if (cancelled) return;
        const list = response?.success ? response.data || [] : [];
        setItems(list);
        setState(list.length ? 'ready' : 'empty');
      })
      .catch(() => {
        if (!cancelled) setState('empty');
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  if (!user || state === 'empty') return null;

  if (state === 'loading') {
    return (
      <section className="rail" aria-busy="true">
        <header className="rail-head">
          <h2 className="rail-title">
            <Sparkles aria-hidden="true" />
            Recommandé pour vous
          </h2>
        </header>
        <div className="rail-track">
          {Array.from({ length: 7 }).map((_, index) => (
            <div key={index} className="rail-item">
              <div className="skeleton" style={{ aspectRatio: '2 / 3', borderRadius: 'var(--r-lg)' }} />
            </div>
          ))}
        </div>
      </section>
    );
  }

  return (
    <Rail
      title="Recommandé pour vous"
      icon={<Sparkles aria-hidden="true" />}
      subtitle="Affiné par vos 👍 et 👎"
    >
      {items.map((movie, index) => (
        <Poster
          key={movie.id}
          index={index}
          title={movie}
          onOpen={onSelectMovie}
          onToggleList={catalog?.onToggleWatchlist}
          inList={catalog?.isInList(movie)}
          watched={catalog?.isWatched(movie)}
        />
      ))}
    </Rail>
  );
}
